import { Autocomplete, CircularProgress, Grid } from "@mui/material";
import StyledTextField from "components/StyledTextField";
import { AvailabilityType } from "operations/schema/schema";
import { FC } from "react";
import { useIntl } from "react-intl";
import { useAppSelector } from "store";

export interface AvailabilityTypeAutoCompleteProps {
  value: AvailabilityType | null;
  onChange: (type: AvailabilityType | null) => void;
}

export const AvailabilityTypeAutoComplete: FC<AvailabilityTypeAutoCompleteProps> = (props) => {
  const { value, onChange } = props;
  const { availabilityTypes, loading } = useAppSelector((s) => s.cache);
  const intl = useIntl();

  return (
    <>
      <Grid item>
        <Autocomplete
          fullWidth
          loading={loading.prefill}
          options={availabilityTypes}
          data-testid="availabilityTypes"
          getOptionLabel={(a: AvailabilityType) => `${a.code} - ${a.description}`}
          isOptionEqualToValue={(option, value) => option.code === value?.code}
          onChange={(_, value: AvailabilityType | null) => {
            onChange(value);
          }}
          value={value}
          renderInput={(params) => (
            <StyledTextField
              name="availabilityType"
              className="availabilityType"
              {...params}
              label={intl.formatMessage({ id: "availability.type" })}
              variant="outlined"
              required
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading.prefill ? <CircularProgress size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </Grid>
    </>
  );
};
